import { createAsyncThunk } from '@reduxjs/toolkit';

import { getSalesAgreement } from '../../utils/core-utils';
import accountApi from '../apis/account-api';
import customerNetApi from '../apis/cnet-api';
import productApi from '../apis/product-api';
import {
  activeUserSelector,
  userDetailsSelector,
} from '../selectors/session-selectors';
import type { AppRootState } from '../store';

const hydrateUserContext = createAsyncThunk<void, { propertyId: string }>(
  'auth/hydrateUserContext',
  async ({ propertyId }, { dispatch, getState }) => {
    const state = getState() as AppRootState;
    const userDetails = userDetailsSelector(state);
    const activeUser = activeUserSelector(state);
    const property = accountApi.endpoints.addressesByPartyId
      .select({ partyId: userDetails!.PERSON_PARTY_ID })(state)
      .data!.responseObject.find(
        property => property.SITE_USE_ID === +propertyId
      )!;

    const accountDetailsPromise = dispatch(
      customerNetApi.springBoot.endpoints.accountDetails.initiate({
        accountNumber: property.ACCOUNT_NUMBER,
        ssoId: activeUser!.sso,
      })
    );

    const partyRelationshipsPromise = accountDetailsPromise
      .unwrap()
      .then(accountDetailsResponse => {
        if (accountDetailsResponse.responseObject?.length) {
          return dispatch(
            customerNetApi.springBoot.endpoints.partyRelationships.initiate({
              partyId: accountDetailsResponse.responseObject[0].PARTYID,
            })
          );
        }
      });

    const salesAgreementsPromise = dispatch(
      customerNetApi.springBoot.endpoints.salesAgreements.initiate({
        accountNumber: property.ACCOUNT_NUMBER,
      })
    );

    void salesAgreementsPromise.then(() => {
      const standardSalesAgreement = getSalesAgreement('Standard Agreement');
      const partsSalesAgreement = getSalesAgreement('GEA Parts');

      void dispatch(
        productApi.endpoints.orderableMenu.initiate({
          accountNumber: standardSalesAgreement.ACCOUNT_NUMBER,
          agreementNumber: standardSalesAgreement.AGREEMENT_NUMBER.toString(),
        })
      );

      if (partsSalesAgreement) {
        void dispatch(
          productApi.endpoints.orderableMenu.initiate({
            accountNumber: partsSalesAgreement.ACCOUNT_NUMBER,
            agreementNumber: partsSalesAgreement.AGREEMENT_NUMBER.toString(),
          })
        );
      }
    });

    await Promise.all([
      accountDetailsPromise,
      partyRelationshipsPromise,
      salesAgreementsPromise,
      // dispatch(customerNetApi.springBoot.endpoints.addressAttributes.initiate({
      //   partySiteId:
      // })),
      dispatch(
        customerNetApi.springBoot.endpoints.shippingLocations.initiate({
          accountNumber: property.ACCOUNT_NUMBER,
          state: property.STATE,
          countryCode: property.COUNTRY,
          postalCode: property.POSTAL_CODE.split('-')[0],
        })
      ),
      dispatch(
        productApi.endpoints.cart.initiate({
          accountNumber: property.ACCOUNT_NUMBER,
        })
      ),
    ]);
  }
);

export default hydrateUserContext;
